import React from "react";
import { useDispatch } from "react-redux";
import { BasicAction } from "widgets/ActionMenu";
import { exportScores, PREDICTIVE_SCORE_ENTITY_TYPES } from "reducers/PredictiveScoring";
import { trackExport } from "utils/PredictiveScoringPendo";

const EXPORT_PREDICTIVE_SCORES = {
	name: "Export Predictive Scores",
	icon: "fas fa-file-excel",
	component: ({ dependentValues = {} }) => {
		const dispatch = useDispatch();
		// buildDropdownList passes the whole action context as `dependentValues`, so the values
		// ImportExportButton nests under `dependentValues` land one level deeper. Read from the
		// nested object, falling back to the top level in case a caller passes a flattened context.
		const { libraryId } = dependentValues;
		const { selectedCreativeIds } = dependentValues.dependentValues || dependentValues;

		function handleClick() {
			trackExport(PREDICTIVE_SCORE_ENTITY_TYPES.CREATIVE, libraryId);
			dispatch(exportScores(libraryId, PREDICTIVE_SCORE_ENTITY_TYPES.CREATIVE, selectedCreativeIds)).then(handleDownload);
		}

		return (
			<BasicAction
				name="Export Predictive Scores"
				iconName="fas fa-file-excel"
				handleClick={handleClick}
			/>
		);
	},
};

const EXPORT_VERSION_PREDICTIVE_SCORES = {
	name: "Export Predictive Scores",
	icon: "fas fa-file-excel",
	component: ({ dependentValues = {} }) => {
		const dispatch = useDispatch();
		// The versions ImportExportButton passes a flat context (selectedVersionIds at top level),
		// while the creatives one nests it — the `|| dependentValues` fallback handles both shapes.
		const { libraryId } = dependentValues;
		const { selectedVersionIds } = dependentValues.dependentValues || dependentValues;

		// A versions export with no selection makes the engine fall back to exporting the whole
		// library's creatives (wrong from a version library), so require a selection. Gray the action
		// out rather than hide it — matching "Export Creative Labels for Selected Versions".
		const selectedCount = selectedVersionIds?.length || 0;
		const label = selectedCount ? `Export Predictive Scores (${selectedCount})` : "Export Predictive Scores";

		function handleClick() {
			if (!selectedCount) { return; }
			trackExport(PREDICTIVE_SCORE_ENTITY_TYPES.VERSION, libraryId);
			dispatch(exportScores(libraryId, PREDICTIVE_SCORE_ENTITY_TYPES.VERSION, selectedVersionIds)).then(handleDownload);
		}

		return (
			<BasicAction
				name={label}
				iconName="fas fa-file-excel"
				handleClick={handleClick}
				isDisabled={!selectedCount}
			/>
		);
	},
};

function handleDownload(response) {
	if (!response || !response.payload || !response.payload.data) {
		return;
	}
	const blob = new Blob([response.payload.data], {
		type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	});
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = `predictive-scores-${Date.now()}.xlsx`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
}

export const PREDICTIVE_SCORING_EXPORT_LIST = [EXPORT_PREDICTIVE_SCORES];
export const PREDICTIVE_SCORING_VERSIONS_EXPORT_LIST = [EXPORT_VERSION_PREDICTIVE_SCORES];
